import { render, staticRenderFns } from "./discdetail.vue?vue&type=template&id=53f059e3&scoped=true"
import script from "./discdetail.vue?vue&type=script&lang=js"
export * from "./discdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f059e3",
  null
  
)

export default component.exports